// extracted by mini-css-extract-plugin
export var md = "_2s-4";
export var semantic = "_2s-5";
export var sm = "_2s-3";
export var text = "_2s-6";
export var toggleInput = "_2s-0";
export var toggleSwitch = "_2s-1";
export var xs = "_2s-2";